import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Error from "./pages/Error";

import { Route, Switch } from "react-router-dom";

import Topbar from "./components/layout/Topbar";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import ResumeStep1 from "./pages/ResumeStep1";
import Home from "./pages/Home";
import CreateResume from "./components/resumes/CreateResume";
import Dashboard from "./components/dashboard/Dashboard";
import JobDetails from "./components/jobs/JobDetails";
import UserProfile from "./components/profile/UserProfile";
import ViewResumes from "./components/resumes/ViewResumes";

function App() {
  return (
    <>
      <Topbar />
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/create-resume" component={CreateResume} />
        <Route exact path="/login" component={SignIn} />
        <Route path="/job/:id" component={JobDetails} />
        <Route exact path="resume-step-1" component={ResumeStep1} />
        <Route exact path="/signin" component={SignIn} />
        <Route exact path="/signup" component={SignUp} />
        <Route path="/user/:id" component={UserProfile} />
        <Route exact path="/view-resumes" component={ViewResumes} />
        <Route component={Error} />
      </Switch>
    </>
  );
}

export default App;
